import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import { TOAST_TYPE } from '../../store/slices/toaster.slice';
import { BaseIcon } from '..';

const ICON_BY_TYPE = {
  [TOAST_TYPE.SUCCESS]: 'check',
  [TOAST_TYPE.WARNING]: 'warning',
  [TOAST_TYPE.ERROR]: 'error',
};

export const Toast = ({ id, body: { type, title }, options, removeToast, children }) => {
  const dispatch = useDispatch();

  const icon = useMemo(() => {
    const iconName = ICON_BY_TYPE[type];
    return iconName ? <BaseIcon icon={iconName} /> : <div />;
  }, [type]);

  const dismiss = useCallback(
    (always) => {
      if ((!always || typeof always !== 'boolean') && options.disableClick) {
        return;
      }
      dispatch(removeToast(id));
    },
    [dispatch, id, options.disableClick, removeToast]
  );

  useEffect(() => {
    const { timeout } = options;
    let timeoutInstance;
    if (typeof timeout === 'number' && timeout > 0) {
      timeoutInstance = setTimeout(() => dismiss(true), timeout);
    }

    return () => {
      if (timeoutInstance) clearTimeout(timeoutInstance);
    };
  }, [dismiss, options]);

  return (
    <div data-testid="toast" className={classNames('toast', `toast--${type}`)}>
      {!options.disableClick && (
        <div className="toast__remove" onClick={() => dismiss(true)}>
          <BaseIcon icon="times" />
        </div>
      )}
      <div className="toast__icon">{icon}</div>
      <div className="toast__content">
        <div className="toast__title">{title}</div>
        <div className="toast__message">{children}</div>
      </div>
    </div>
  );
};

export default Toast;
